import { formatDistanceToNow } from 'date-fns'
import { Link } from 'react-router'
import type { Audience } from '@/types/newsletter'

interface AudienceCardProps {
  audience: Audience
}

export function AudienceCard({ audience }: AudienceCardProps): React.JSX.Element {
  return (
    <Link
      to={`/audiences/${audience.id}`}
      className="block rounded-xl border border-surface-3 bg-surface-0 p-4 transition-colors hover:border-brand-300 hover:bg-surface-1"
    >
      <h3 className="font-medium text-text-primary">{audience.name}</h3>
      {audience.description && (
        <p className="mt-1 line-clamp-2 text-sm text-text-secondary">{audience.description}</p>
      )}

      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <span className="text-lg font-semibold text-text-primary">
            {audience.subscriber_count.toLocaleString()}
          </span>
          <span className="text-sm text-text-secondary">subscribers</span>
        </div>
        <span className="text-xs text-text-tertiary">
          Updated {formatDistanceToNow(new Date(audience.updated_at), { addSuffix: true })}
        </span>
      </div>
    </Link>
  )
}
